'use client'

import { Accordion, AccordionItem, Column, Grid } from '@carbon/react'
import type { HomeExtraCopy } from '@/lib/home-extra-i18n'

export function HomeFaqSection({ copy }: { copy: HomeExtraCopy }) {
  return (
    <section id="faq" className="section faq-section" aria-labelledby="faq-title">
      <Grid>
        <Column sm={4} md={4} lg={5}>
          <p className="section-label">{copy.needHelp}</p>
          <h2 id="faq-title" className="section__title">{copy.commonQuestions}</h2>
          <p className="section__subtitle">{copy.faqIntro}</p>
        </Column>
        <Column sm={4} md={4} lg={{ span: 10, offset: 1 }}>
          <Accordion className="faq-accordion" size="lg">
            {copy.faq.map(({ question, answer }) => (
              <AccordionItem key={question} title={question}>
                <p>{answer}</p>
              </AccordionItem>
            ))}
          </Accordion>
        </Column>
      </Grid>
    </section>
  )
}
